<template>
  <div class="vx-col w-full lg:w-1/3 sm:w-full mb-base">
    <vx-card>
      <span class="title-head">ชำระเงินงวดค้างชำระ</span><br><br><br>
      <span class="label-bold">ยอดหนี้ที่ต้องชำระในงวดค้างชำระ</span><br><br>
      <div class="vx-row flex" v-if="paidFeeOutstanding > 0 && paymentAmountOutstanding > 0">
        <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidFeeOutstanding | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidPenaltyOutstanding > 0 && paymentAmountOutstanding > 0">
        <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidPenaltyOutstanding | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidInterestOutstanding > 0 && paymentAmountOutstanding > 0">
        <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidInterestOutstanding | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidPrincipleOutstanding > 0 && paymentAmountOutstanding > 0">
        <span class="vx-col flex-1 text-left label">เงินต้น</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidPrincipleOutstanding | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-for="index in paidSpace" :key="index">
        <span class="vx-col flex-1 text-left label">&nbsp;</span>
        <span class="vx-col flex-1 text-right label-bold">&nbsp;</span>
      </div>
      <br>

      <br><br>

      <div class="vx-row flex">
        <span class="vx-col flex-1 text-left label">ยอดรวม</span>
        <div class="vx-col flex-1 text-right"><span class="money-bold">{{ paymentAmountOutstanding | numberFormat }} </span> <span class="label-bold">บาท</span></div>
      </div><br>
      <vs-button v-if="!isStudentSupportReadOnly" type="filled" :disabled="disabledSubmit" class="w-full" color="primary" @click="btnQrPayment('outstanding', 0)">ชำระเงิน</vs-button>
    </vx-card>
  </div>
</template>

<script>

const moment = require('moment');
import { createNamespacedHelpers } from 'vuex'

const { mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  name: "PaymentOutstanding",
  props: {
    btnQrPayment: Function,
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailOutstanding', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    disabledSubmit() {
      if( this.paymentAmount <= 0 ) { return true }
      else { return false }
    },
    paymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.paymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    lastPaymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.lastPaymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    paidSpace(){
      let space = 4
      if(this.paidFeeOutstanding >= 1) space--
      if(this.paidPenaltyOutstanding >= 1) space--
      if(this.paidInterestOutstanding >= 1) space--
      if(this.paidPrincipleOutstanding >= 1) space--
      return space
    },

    paymentAmountOutstanding(){
      if(!this.paymentAmountDetailOutstanding) return 0.00
      return this.paymentAmountDetailOutstanding.amount
    },
    paidFeeOutstanding(){
      if(!this.paymentAmountDetailOutstanding) return 0.00
      return this.paymentAmountDetailOutstanding.paidFee
    },
    paidPenaltyOutstanding(){
      if(!this.paymentAmountDetailOutstanding) return 0.00
      return this.paymentAmountDetailOutstanding.paidPenalty
    },
    paidInterestOutstanding(){ //accruedInterestRemain
      if(!this.paymentAmountDetailOutstanding) return 0.00
      return this.paymentAmountDetailOutstanding.paidInterest
    },
    paidPrincipleOutstanding(){
      if(!this.paymentAmountDetailOutstanding) return 0.00
      return this.paymentAmountDetailOutstanding.paidPrinciple
    },
  },
}
</script>

<style scoped>

</style>
